import React, { Fragment, useState, useEffect } from 'react'
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap'
import { barChart, progress1, progress2, progress3, progress4, progress5 } from './charts-data'
import { Database, ShoppingBag, MessageCircle, UserPlus, Layers, ShoppingCart, DollarSign, ArrowDown, ArrowUp, CloudDrizzle } from 'react-feather';
import CountUp from 'react-countup';
import Chart from 'react-apexcharts'

import { Icon } from '@iconify/react';
import { SALE } from '../../../constant'

import { createClient } from "@supabase/supabase-js";
import configDB from '../../../data/customizer/config'


const Sample = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
  const secondary = localStorage.getItem('secondary_color') || configDB.data.color.secondary_color;

  const [totalamount, settotalamount] = useState("")
  const [peramount, setperamount] = useState([])
  const [tripdate, settripdate] = useState([])
  const [tripquantity, settripquantity] = useState([])
  const [trip_status, settrip_status] = useState([])
  const [totaltrip, settotaltrip] = useState("")
  const [totaluser, settotaluser] = useState("")
  const [expense, setexpense] = useState([])
  const [netprofit, setnetprofit] = useState([])
  const [revenue, setrevenue] = useState([])
  const [completedtrip, setcompletedtrip] = useState("")
  useEffect(() => {
    setTimeout(()=>{
      if(window.localStorage.getItem('usertype') === "Supplier"){

        getTripDetail()
      }else if(window.localStorage.getItem('usertype') === "Driver"){
        getdriverTripDetail()
      }else if(window.localStorage.getItem('usertype') === "Buyer"){
        getbuyerTripDetail()
      }
        else{
        getvehicleTripDetail()
      }
      user()
    },1000)

   
  }, [])
  async function user(){
    let { data: totaluser, error } = await supabase
    .from('User_Details')
    .select("*")
    
    settotaluser(totaluser.length)
  }
  async function getTripDetail() {
    console.log("getTripDetail")

    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))
      .order('id', { ascending: true })


    if (trip_Details !== null && trip_Details.length > 0) {
      let completedtripcount = 0
      for(let i=0;i<trip_Details.length;i++){
        if(trip_Details[i].delivery_status === "Delivered"){
          completedtripcount++
        }
      }
      setcompletedtrip(completedtripcount)
      
      let mainrevenueamount = []
      let mainexpenseamount = []
      let mainnetprofitamount = []
      for(let i=0;i<trip_Details.length;i++){
        var date = new Date(trip_Details[i].trip_date)
        var revenue = []
        var expense = []
        var netprofit = []
        for(let j=0;j<12;j++){
          if(date.getMonth()===j){
            var revenueamount = parseInt(trip_Details[i].trip_amount)+parseInt(trip_Details[i].transport_charges)
            var expenseamount =(parseInt(trip_Details[i].transport_charges)+((parseInt(trip_Details[i].trip_amount)*18)/100)+((parseInt(trip_Details[i].transport_charges)*5)/100))
            var netprofitamount = parseInt(revenueamount-expenseamount)*40/100
            revenue.push(revenueamount)
            expense.push(expenseamount)
            netprofit.push(netprofitamount)
          }else{
            revenue.push(0)
            expense.push(0)
            netprofit.push(0)
          }
        
        }
        mainrevenueamount.push(revenue)
        mainexpenseamount.push(expense)
        mainnetprofitamount.push(netprofit)
        
      }
      let totalrevenue = []
      let totalexpense = []
      let totalnetprofit = []
      for(let i=0;i<12;i++){
        let revenueamount = 0
        let expenseamount = 0
        let netprofitamount = 0
        for(let j=0;j<mainrevenueamount.length;j++){
          revenueamount = revenueamount+mainrevenueamount[j][i]
          expenseamount = expenseamount+mainexpenseamount[j][i]
          netprofitamount = netprofitamount+mainnetprofitamount[j][i]
        }
        totalrevenue.push(revenueamount)
        totalexpense.push(expenseamount)
        totalnetprofit.push(netprofitamount)
      }
      setrevenue(totalrevenue)
      setexpense(totalexpense)
      setnetprofit(totalnetprofit)

      settotaltrip(trip_Details.length)
      

      var amount = 0
      for (let i = 0; i < trip_Details.length; i++) {
        amount = amount + trip_Details[i].trip_amount

      }
      settotalamount(amount)
      var sortamount = []
      for (let i = 0; i < trip_Details.length; i++) {
        var per = trip_Details[i].trip_amount
        sortamount.push(per)
      }
      
      
      setperamount(sortamount)
      for (let i = 0; i < trip_Details.length; i++) {
        var date = trip_Details[i].trip_date
        settripdate(tripdate => [...tripdate, date])
      }
      var sortquantity = []
      for (let i = 0; i < trip_Details.length; i++) {
        var quantity = trip_Details[i].inventory_quantity
        sortquantity.push(quantity)
      }
     
      
      settripquantity(sortquantity)

      for (let i = 0; i < trip_Details.length; i++) {
       
        
        var percentage = 0
        if (trip_Details[i].pick_up !== "" || trip_Details[i].pick_up !== null && trip_Details[i].drop_off !== "" || trip_Details[i].drop_off !== null) {
          percentage = 15
          if (trip_Details[i].vehicle_status === "true") {
            percentage = 25
            if (trip_Details[i].payment_status === "Paid") {
              percentage = 50

              if (trip_Details[i].driver_status === "true") {
                percentage = 75
                if (trip_Details[i].delivery_status === "Delivered") {
                  percentage = 100
                } else {
                  percentage = 75
                }
              } else {
                percentage = 50
              }



            } else {
              percentage = 25
            }
          } else {
            percentage = 15
          }
        } else {
          percentage = 0
        }
        var backgroundColor = ""
        var colorcode = ""
        if (percentage === 0) {
          backgroundColor = "#f2f2f2"
          colorcode = "#fb2e63"
        }else if(percentage === 15){
          backgroundColor = '#f2f2f2'
          colorcode = "#fb740d"
        }else if(percentage === 25){
          backgroundColor = '#f2f2f2'
          colorcode = "#158df7"
        }else if(percentage === 50){
          backgroundColor = '#f2f2f2'
          colorcode = "#544fff"
        }else if(percentage === 75){
          backgroundColor = '#f2f2f2'
          colorcode = "lightgreen"
        }else{
          backgroundColor = '#f2f2f2'
          colorcode = "#51bb25"
        }
        var data = {
          percentage: percentage,
          colorcode: colorcode,
          backgroundColor: backgroundColor
        }
        settrip_status(trip_status => [...trip_status, data])

      }



    }

  }
  async function getvehicleTripDetail() {

    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("vehicle_id", localStorage.getItem("userid"))
      .order('id', { ascending: true })


    if (trip_Details !== null && trip_Details.length > 0) {
      let completedtripcount = 0
      for(let i=0;i<trip_Details.length;i++){
        if(trip_Details[i].delivery_status === "Delivered"){
          completedtripcount++
        }
      }
      setcompletedtrip(completedtripcount)
      let mainrevenueamount = []
      let mainexpenseamount = []
      let mainnetprofitamount = []
      for(let i=0;i<trip_Details.length;i++){
        var date = new Date(trip_Details[i].trip_date)
        var revenue = []
        var expense = []
        var netprofit = []
        for(let j=0;j<12;j++){
          if(date.getMonth()===j){
            var revenueamount = parseInt(trip_Details[i].trip_amount)+parseInt(trip_Details[i].transport_charges)
            var expenseamount =(parseInt(trip_Details[i].transport_charges)+((parseInt(trip_Details[i].trip_amount)*18)/100)+((parseInt(trip_Details[i].transport_charges)*5)/100))
            var netprofitamount = parseInt(revenueamount-expenseamount)*40/100
            revenue.push(revenueamount)
            expense.push(expenseamount)
            netprofit.push(netprofitamount)
          }else{
            revenue.push(0)
            expense.push(0)
            netprofit.push(0)
          }
        
        }
        mainrevenueamount.push(revenue)
        mainexpenseamount.push(expense)
        mainnetprofitamount.push(netprofit)
        
      }
      let totalrevenue = []
      let totalexpense = []
      let totalnetprofit = []
      for(let i=0;i<12;i++){
        let revenueamount = 0
        let expenseamount = 0
        let netprofitamount = 0
        for(let j=0;j<mainrevenueamount.length;j++){
          revenueamount = revenueamount+mainrevenueamount[j][i]
          expenseamount = expenseamount+mainexpenseamount[j][i]
          netprofitamount = netprofitamount+mainnetprofitamount[j][i]
        }
        totalrevenue.push(revenueamount)
        totalexpense.push(expenseamount)
        totalnetprofit.push(netprofitamount)
      }
      setrevenue(totalrevenue)
      setexpense(totalexpense)
      setnetprofit(totalnetprofit)

      settotaltrip(trip_Details.length)
      

      var amount = 0
      for (let i = 0; i < trip_Details.length; i++) {
        amount = amount + trip_Details[i].transport_charges

      }
      settotalamount(amount)
      var sortamount = []
      for (let i = 0; i < trip_Details.length; i++) {
        var per = trip_Details[i].transport_charges
        sortamount.push(per)
      }
      
      
      setperamount(sortamount)
      for (let i = 0; i < trip_Details.length; i++) {
        var date = trip_Details[i].trip_date
        settripdate(tripdate => [...tripdate, date])
      }
      var sortquantity = []
      for (let i = 0; i < trip_Details.length; i++) {
        var quantity = trip_Details[i].inventory_quantity
        sortquantity.push(quantity)
      }
     
      
      settripquantity(sortquantity)

      for (let i = 0; i < trip_Details.length; i++) {
       
        
        var percentage = 0
        if (trip_Details[i].pick_up !== "" || trip_Details[i].pick_up !== null && trip_Details[i].drop_off !== "" || trip_Details[i].drop_off !== null) {
          percentage = 15
          if (trip_Details[i].vehicle_status === "true") {
            percentage = 25
            if (trip_Details[i].payment_status === "Paid") {
              percentage = 50

              if (trip_Details[i].driver_status === "true") {
                percentage = 75
                if (trip_Details[i].delivery_status === "Delivered") {
                  percentage = 100
                } else {
                  percentage = 75
                }
              } else {
                percentage = 50
              }



            } else {
              percentage = 25
            }
          } else {
            percentage = 15
          }
        } else {
          percentage = 0
        }
        var backgroundColor = ""
        var colorcode = ""
        if (percentage === 0) {
          backgroundColor = "#f2f2f2"
          colorcode = "#fb2e63"
        }else if(percentage === 15){
          backgroundColor = '#f2f2f2'
          colorcode = "#fb740d"
        }else if(percentage === 25){
          backgroundColor = '#f2f2f2'
          colorcode = "#158df7"
        }else if(percentage === 50){
          backgroundColor = '#f2f2f2'
          colorcode = "#544fff"
        }else if(percentage === 75){
          backgroundColor = '#f2f2f2'
          colorcode = "lightgreen"
        }else{
          backgroundColor = '#f2f2f2'
          colorcode = "#51bb25"
        }
        var data = {
          percentage: percentage,
          colorcode: colorcode,
          backgroundColor: backgroundColor
        }
        settrip_status(trip_status => [...trip_status, data])

      }



    }

  }
  async function getdriverTripDetail() {

    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("driverid", localStorage.getItem("userid"))
      .order('id', { ascending: true })


    if (trip_Details !== null && trip_Details.length > 0) {
      let completedtripcount = 0
      for(let i=0;i<trip_Details.length;i++){
        if(trip_Details[i].delivery_status === "Delivered"){
          completedtripcount++
        }
      }
      setcompletedtrip(completedtripcount)
      let mainrevenueamount = []
      let mainexpenseamount = []
      let mainnetprofitamount = []
      for(let i=0;i<trip_Details.length;i++){
        var date = new Date(trip_Details[i].trip_date)
        var revenue = []
        var expense = []
        var netprofit = []
        for(let j=0;j<12;j++){
          if(date.getMonth()===j){
            var revenueamount = parseInt(trip_Details[i].trip_amount)+parseInt(trip_Details[i].transport_charges)
            var expenseamount =(parseInt(trip_Details[i].transport_charges)+((parseInt(trip_Details[i].trip_amount)*18)/100)+((parseInt(trip_Details[i].transport_charges)*5)/100))
            var netprofitamount = parseInt(revenueamount-expenseamount)*40/100
            revenue.push(revenueamount)
            expense.push(expenseamount)
            netprofit.push(netprofitamount)
          }else{
            revenue.push(0)
            expense.push(0)
            netprofit.push(0)
          }
        
        }
        mainrevenueamount.push(revenue)
        mainexpenseamount.push(expense)
        mainnetprofitamount.push(netprofit)
        
      }
      let totalrevenue = []
      let totalexpense = []
      let totalnetprofit = []
      for(let i=0;i<12;i++){
        let revenueamount = 0
        let expenseamount = 0
        let netprofitamount = 0
        for(let j=0;j<mainrevenueamount.length;j++){
          revenueamount = revenueamount+mainrevenueamount[j][i]
          expenseamount = expenseamount+mainexpenseamount[j][i]
          netprofitamount = netprofitamount+mainnetprofitamount[j][i]
        }
        totalrevenue.push(revenueamount)
        totalexpense.push(expenseamount)
        totalnetprofit.push(netprofitamount)
      }
      setrevenue(totalrevenue)
      setexpense(totalexpense)
      setnetprofit(totalnetprofit)

      settotaltrip(trip_Details.length)
      

      var amount = 0
      for (let i = 0; i < trip_Details.length; i++) {
        amount = amount + trip_Details[i].transport_charges

      }
      settotalamount(amount)
      var sortamount = []
      for (let i = 0; i < trip_Details.length; i++) {
        var per = trip_Details[i].transport_charges
        sortamount.push(per)
      }
      
      
      setperamount(sortamount)
      for (let i = 0; i < trip_Details.length; i++) {
        var date = trip_Details[i].trip_date
        settripdate(tripdate => [...tripdate, date])
      }
      var sortquantity = []
      for (let i = 0; i < trip_Details.length; i++) {
        var quantity = trip_Details[i].inventory_quantity
        sortquantity.push(quantity)
      }
     
      
      settripquantity(sortquantity)

      for (let i = 0; i < trip_Details.length; i++) {
       
        
        var percentage = 0
        if (trip_Details[i].pick_up !== "" || trip_Details[i].pick_up !== null && trip_Details[i].drop_off !== "" || trip_Details[i].drop_off !== null) {
          percentage = 15
          if (trip_Details[i].vehicle_status === "true") {
            percentage = 25
            if (trip_Details[i].payment_status === "Paid") {
              percentage = 50

              if (trip_Details[i].driver_status === "true") {
                percentage = 75
                if (trip_Details[i].delivery_status === "Delivered") {
                  percentage = 100
                } else {
                  percentage = 75
                }
              } else {
                percentage = 50
              }



            } else {
              percentage = 25
            }
          } else {
            percentage = 15
          }
        } else {
          percentage = 0
        }
        var backgroundColor = ""
        var colorcode = ""
        if (percentage === 0) {
          backgroundColor = "#f2f2f2"
          colorcode = "#fb2e63"
        }else if(percentage === 15){
          backgroundColor = '#f2f2f2'
          colorcode = "#fb740d"
        }else if(percentage === 25){
          backgroundColor = '#f2f2f2'
          colorcode = "#158df7"
        }else if(percentage === 50){
          backgroundColor = '#f2f2f2'
          colorcode = "#544fff"
        }else if(percentage === 75){
          backgroundColor = '#f2f2f2'
          colorcode = "lightgreen"
        }else{
          backgroundColor = '#f2f2f2'
          colorcode = "#51bb25"
        }
        var data = {
          percentage: percentage,
          colorcode: colorcode,
          backgroundColor: backgroundColor
        }
        settrip_status(trip_status => [...trip_status, data])

      }



    }

  }
  async function getbuyerTripDetail() {

    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("customer_id", localStorage.getItem("userid"))
      .order('id', { ascending: true })
      


    if (trip_Details !== null && trip_Details.length > 0) {
      let completedtripcount = 0
      for(let i=0;i<trip_Details.length;i++){
        if(trip_Details[i].delivery_status === "Delivered"){
          completedtripcount++
        }
      }
      setcompletedtrip(completedtripcount)
      let mainrevenueamount = []
      let mainexpenseamount = []
      let mainnetprofitamount = []
      for(let i=0;i<trip_Details.length;i++){
        var date = new Date(trip_Details[i].trip_date)
        var revenue = []
        var expense = []
        var netprofit = []
        for(let j=0;j<12;j++){
          if(date.getMonth()===j){
            var revenueamount = parseInt(trip_Details[i].trip_amount)+parseInt(trip_Details[i].transport_charges)
            var expenseamount =(parseInt(trip_Details[i].transport_charges)+((parseInt(trip_Details[i].trip_amount)*18)/100)+((parseInt(trip_Details[i].transport_charges)*5)/100))
            var netprofitamount = parseInt(revenueamount-expenseamount)*40/100
            revenue.push(revenueamount)
            expense.push(expenseamount)
            netprofit.push(netprofitamount)
          }else{
            revenue.push(0)
            expense.push(0)
            netprofit.push(0)
          }
        
        }
        mainrevenueamount.push(revenue)
        mainexpenseamount.push(expense)
        mainnetprofitamount.push(netprofit)
        
      }
      let totalrevenue = []
      let totalexpense = []
      let totalnetprofit = []
      for(let i=0;i<12;i++){
        let revenueamount = 0
        let expenseamount = 0
        let netprofitamount = 0
        for(let j=0;j<mainrevenueamount.length;j++){
          revenueamount = revenueamount+mainrevenueamount[j][i]
          expenseamount = expenseamount+mainexpenseamount[j][i]
          netprofitamount = netprofitamount+mainnetprofitamount[j][i]
        }
        totalrevenue.push(revenueamount)
        totalexpense.push(expenseamount)
        totalnetprofit.push(netprofitamount)
      }
      setrevenue(totalrevenue)
      setexpense(totalexpense)
      setnetprofit(totalnetprofit)

      settotaltrip(trip_Details.length)
      

      var amount = 0
      for (let i = 0; i < trip_Details.length; i++) {
        amount = amount + trip_Details[i].trip_amount

      }
      settotalamount(amount)
      var sortamount = []
      for (let i = 0; i < trip_Details.length; i++) {
        var per = trip_Details[i].trip_amount
        sortamount.push(per)
      }
      
      
      setperamount(sortamount)
      for (let i = 0; i < trip_Details.length; i++) {
        var date = trip_Details[i].trip_date
        settripdate(tripdate => [...tripdate, date])
      }
      var sortquantity = []
      for (let i = 0; i < trip_Details.length; i++) {
        var quantity = trip_Details[i].inventory_quantity
        sortquantity.push(quantity)
      }
     
      
      settripquantity(sortquantity)

      for (let i = 0; i < trip_Details.length; i++) {
       
        
        var percentage = 0
        if (trip_Details[i].pick_up !== "" || trip_Details[i].pick_up !== null && trip_Details[i].drop_off !== "" || trip_Details[i].drop_off !== null) {
          percentage = 15
          if (trip_Details[i].vehicle_status === "true") {
            percentage = 25
            if (trip_Details[i].payment_status === "Paid") {
              percentage = 50

              if (trip_Details[i].driver_status === "true") {
                percentage = 75
                if (trip_Details[i].delivery_status === "Delivered") {
                  percentage = 100
                } else {
                  percentage = 75
                }
              } else {
                percentage = 50
              }



            } else {
              percentage = 25
            }
          } else {
            percentage = 15
          }
        } else {
          percentage = 0
        }
        var backgroundColor = ""
        var colorcode = ""
        if (percentage === 0) {
          backgroundColor = "#f2f2f2"
          colorcode = "#fb2e63"
        }else if(percentage === 15){
          backgroundColor = '#f2f2f2'
          colorcode = "#fb740d"
        }else if(percentage === 25){
          backgroundColor = '#f2f2f2'
          colorcode = "#158df7"
        }else if(percentage === 50){
          backgroundColor = '#f2f2f2'
          colorcode = "#544fff"
        }else if(percentage === 75){
          backgroundColor = '#f2f2f2'
          colorcode = "lightgreen"
        }else{
          backgroundColor = '#f2f2f2'
          colorcode = "#51bb25"
        }
        var data = {
          percentage: percentage,
          colorcode: colorcode,
          backgroundColor: backgroundColor
        }
        settrip_status(trip_status => [...trip_status, data])

      }



    }

  }

  const saleoptions = {
    chart: {
      toolbar: {
        show: false
      },
      height: 300,
      type: 'area'
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    xaxis: {
      show: false,
      type: 'datetime',
      categories: tripdate,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
        bottom: -40
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 100]
      },

    },
    colors: [primary],
    tooltip: {
      x: {
        format: 'dd/MM/yy'
      }
    }
  }
  const saleseries = [
    {
      name: 'Trip Amount',
      data: peramount
    }
  ]
  const totaltripoptions = {
    chart: {
      toolbar: {
        show: false
      },
      height: 300,
      type: 'area'
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    xaxis: {
      show: false,
      type: 'datetime',
      categories: tripdate,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
        bottom: -40
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 100]
      }

    },
    colors: [secondary],
    tooltip: {
      x: {
        format: 'dd/MM/yy'
      }
    },

  }
  const totaltripseries = [
    {
      name: 'Quantity',
      data: tripquantity
    }
  ]
  const expenseseries = [{
    name: 'Net Profit',
    data: netprofit
}, {
    name: 'Revenue',
    data: revenue
}, {
    name: 'Expense',
    data: expense
}]



  return (
    <Fragment>
      <Breadcrumb parent="Widgets" title="Dashboard" />
      <Container fluid={true}>
        <Row>
        <Col sm="6" xl="3" lg="6" style={window.innerWidth<800?{width:"50%"}:{color:"black"}}>
            <Card className="o-hidden">
              <CardBody className="bg b-r-4 card-body">
                <div className="media static-top-widget">
                  <div className="align-self-center text-center"><Database /></div>
                  <div className="media-body"><span className="m-0">{"Earnings"}</span>
                    <h4 className="mb-0 counter"><CountUp end={totalamount} /></h4><Database className="icon-bg" />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col sm="6" xl="3" lg="6" style={window.innerWidth<800?{width:"50%"}:{color:"black"}}>
            <Card className="o-hidden">
              <div className="bg b-r-4 card-body">
                <div className="media static-top-widget">
                  <div className="align-self-center text-center"><Icon icon="bx:trip" color="black" width="35" height="35" /></div>
                  <div className="media-body"><span className="m-0">{"Trip"}</span>
                    <h4 className="mb-0 counter"><CountUp end={totaltrip} /></h4><Icon icon="bx:trip" className="icon-bg" />
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <Col sm="6" xl="3" lg="6" style={window.innerWidth<800?{width:"50%"}:{color:"black"}}>
            <Card className="o-hidden">
              <CardBody className="bg b-r-4">
                <div className="media static-top-widget">
                  <div className="align-self-center text-center"><Icon icon="carbon:task-complete" color="black" width="35" height="35" /></div>
                  <div className="media-body"><span className="m-0">{"Completed Trip"}</span>
                    <h4 className="mb-0 counter"><CountUp end={completedtrip} /></h4><Icon icon="carbon:task-complete"  className="icon-bg" />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col sm="6" xl="3" lg="6" style={window.innerWidth<800?{width:"50%"}:{color:"black"}}>
            <Card className="o-hidden">
              <CardBody className="bg b-r-4">
                <div className="media static-top-widget">
                  <div className="align-self-center text-center"><UserPlus /></div>
                  <div className="media-body"><span className="m-0">{"NewUser"}</span>
                    <h4 className="mb-0 counter"><CountUp end={totaluser} /></h4><UserPlus className="icon-bg" />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4" md="12" className="box-col-12">
            <Card className="o-hidden">
              <div className="chart-widget-top">
                <Row className="card-body">
                  <Col xs="6">
                    <h6 className="f-w-600 font-primary">{SALE}</h6><span className="num"><span className="counter">{""}</span>{""}</span>
                  </Col>
                  <Col xs="6" className="text-right">
                    <h4 className="num total-value">&#8377; &nbsp;<span className="counter">{totalamount}</span></h4>
                  </Col>
                </Row>
                <div>
                  <div id="chart-widget1">
                    <Chart options={saleoptions} series={saleseries} height="300" type="area" />
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl="4" md="12" className="box-col-12">
            <Card className="o-hidden">
              <div className="chart-widget-top">
                <Row className="card-body">
                  <Col xs="6">
                    <h6 className="f-w-600 font-success">{"Total Trip"}</h6><span className="num"><span className="counter">{""}</span>{""}</span>
                  </Col>
                  <Col xs="6" className="text-right">
                    <h4 className="num total-value"><span className="counter">{totaltrip}</span></h4>
                  </Col>
                </Row>
                <div>
                  <div id="chart-widget2">
                    <Chart className="flot-chart-placeholder" options={totaltripoptions} series={totaltripseries} height="300" type="area" />
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <Col xl="4" lg="12" className="box-col-6 xl-50">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs="9">
                    <h6 className="f-w-600 font-warning">{"Trip Status"}</h6>
                  </Col>
                  <Col xs="3" className="text-right"><ShoppingBag className="text-muted" /></Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-container">
                  {trip_status.length > 0 && trip_status.map((item, index) => {
                    return (
                      <div id={'progress' + (index + 1)} key={index}>
                        <Chart options={{
                          chart: {
                            width: 990,
                            height: 70,
                            type: "bar",
                            stacked: true,
                            sparkline: {
                              enabled: true
                            }
                          },
                          stroke: {
                            width: 0,
                          },
                          fill: {
                            colors: [item.colorcode],
                            type: 'gradient',
                            gradient: {
                              gradientToColors: [item.colorcode],
                            }
                          },
                          legend: {
                            show: true
                          },
                          colors: [item.colorcode],
                          plotOptions: {
                            bar: {
                              horizontal: true,
                              barHeight: '20%',
                              colors: {
                                backgroundBarColors: [item.backgroundColor]
                              }
                            },
                          },
                          title: {
                            floating: true,
                            offsetX: -10,
                            offsetY: 5,
                            text: `Trip ${index + 1}`
                          },
                          subtitle: {
                            floating: true,
                            align: 'right',
                            offsetY: 0,
                            text: `${item.percentage}%`,
                            style: {
                              fontSize: '20px'
                            }
                          },
                          tooltip: {
                            enabled: false
                          },
                          xaxis: {
                            categories: [`Trip ${index + 1}`],
                          },
                          yaxis: {
                            max: 100
                          },
                        }} series={[{
                          name: `Trip ${index + 1}`,
                          data: [item.percentage]
                        }]} height="70" type="bar" />
                      </div>
                    )
                  })
                  }


                </div>
              </CardBody>
            </Card>
          </Col>
          {/* <Col xl="3" className="xl-50 col-sm-6 box-col-6">
            <Card>
              <div className="weather-widget-two" style={{backgroundColor:"gray"}}>
                <CardBody>
                  
                  <div className="media">
                    <svg className="climacon climacon_cloudDrizzle" id="cloudDrizzle" version="1.1" viewBox="15 15 70 70">
                      <g className="climacon_iconWrap climacon_iconWrap-cloudDrizzle">
                        <g className="climacon_wrapperComponent climacon_wrapperComponent-drizzle">
                          <path className="climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-left" d="M42.001,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2.001-0.895-2.001-2v-3.998C40,54.538,40.896,53.644,42.001,53.644z"></path>
                          <path className="climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-middle" d="M49.999,53.644c1.104,0,2,0.896,2,2v4c0,1.104-0.896,2-2,2s-1.998-0.896-1.998-2v-4C48.001,54.54,48.896,53.644,49.999,53.644z"></path>
                          <path className="climacon_component climacon_component-stroke climacon_component-stroke_drizzle climacon_component-stroke_drizzle-right" d="M57.999,53.644c1.104,0,2,0.896,2,2v3.998c0,1.105-0.896,2-2,2c-1.105,0-2-0.895-2-2v-3.998C55.999,54.538,56.894,53.644,57.999,53.644z"></path>
                        </g>
                        <g className="climacon_wrapperComponent climacon_wrapperComponent-cloud">
                          <path className="climacon_component climacon_component-stroke climacon_component-stroke_cloud" d="M63.999,64.944v-4.381c2.387-1.386,3.998-3.961,3.998-6.92c0-4.418-3.58-8-7.998-8c-1.603,0-3.084,0.481-4.334,1.291c-1.232-5.316-5.973-9.29-11.664-9.29c-6.628,0-11.999,5.372-11.999,12c0,3.549,1.55,6.729,3.998,8.926v4.914c-4.776-2.769-7.998-7.922-7.998-13.84c0-8.836,7.162-15.999,15.999-15.999c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.336-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12C71.997,58.864,68.655,63.296,63.999,64.944z"></path>
                        </g>
                      </g>
                    </svg>
                    <div className="media-body align-self-center text-white">
                      <h4 className="m-0 f-w-600 num">{"35°C"}</h4>
                      <p className="m-0 f-14">{"India"}</p>
                    </div>
                  </div>
                  <div className="top-bg-whether">
                    <svg className="climacon climacon_cloudHailAltFill" id="cloudHailAltFill" version="1.1" viewBox="15 15 70 70">
                      <g className="climacon_iconWrap climacon_iconWrap-cloudHailAltFill">
                        <g className="climacon_wrapperComponent climacon_wrapperComponent-hailAlt">
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left">
                            <circle cx="42" cy="65.498" r="2"></circle>
                          </g>
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle">
                            <circle cx="49.999" cy="65.498" r="2"></circle>
                          </g>
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right">
                            <circle cx="57.998" cy="65.498" r="2"></circle>
                          </g>
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-left">
                            <circle cx="42" cy="65.498" r="2"></circle>
                          </g>
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-middle">
                            <circle cx="49.999" cy="65.498" r="2"></circle>
                          </g>
                          <g className="climacon_component climacon_component-stroke climacon_component-stroke_hailAlt climacon_component-stroke_hailAlt-right">
                            <circle cx="57.998" cy="65.498" r="2"></circle>
                          </g>
                        </g>
                        <g className="climacon_componentWrap climacon_componentWrap_cloud">
                          <path className="climacon_component climacon_component-stroke climacon_component-stroke_cloud" d="M43.945,65.639c-8.835,0-15.998-7.162-15.998-15.998c0-8.836,7.163-15.998,15.998-15.998c6.004,0,11.229,3.312,13.965,8.203c0.664-0.113,1.338-0.205,2.033-0.205c6.627,0,11.998,5.373,11.998,12c0,6.625-5.371,11.998-11.998,11.998C57.168,65.639,47.143,65.639,43.945,65.639z"></path>
                          <path className="climacon_component climacon_component-fill climacon_component-fill_cloud" fill="#FFFFFF" d="M59.943,61.639c4.418,0,8-3.582,8-7.998c0-4.417-3.582-8-8-8c-1.601,0-3.082,0.481-4.334,1.291c-1.23-5.316-5.973-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,11.999c0,6.626,5.372,11.998,11.998,11.998C47.562,61.639,56.924,61.639,59.943,61.639z"></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="bottom-whetherinfo">
                    <Row>
                      <Col>
                        <CloudDrizzle />
                      </Col>
                      <Col>
                        <div className="whether-content"><span>{"India_Delhi"}</span>
                          <h4 className="num mb-0">{"36°F"}</h4>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </div>
            </Card>
          </Col> */}

        </Row>

       {window.localStorage.getItem('usertype') === "Supplier"?
        <Row>
        <Col xl="12" md="12" className="box-col-12">
          <Card className="o-hidden">
            <CardHeader>
              <h6 className="f-w-600 font-danger">{"Expenses"}</h6>
            </CardHeader>
            <div className="bar-chart-widget">
              <CardBody className="bottom-content">
                <Row className="row">
                  <Col xs="12">
                    <div id="chart-widget4">
                      <Chart options={barChart.options} series={expenseseries} height="180" type="bar" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </div>
          </Card>
        </Col>


       
      </Row>
       :"" }
       <br/>
       <br/>



      </Container>
    </Fragment>
  )
}

export default Sample;